export default __webpack_public_path__ + "static/media/luna.d363aa11.jpg";